export enum MemberLevel {
    SERVICEPROVIDER = "ServiceProvider",
    ROLE = "ServiceProviderRole",
    EMPLOYEE = "ServiceProviderEmployee",
    ALL = "All"
};
